export default __webpack_public_path__ + "static/media/mujer.0c8f998d.png";